const initialState = {
  loading: false,
  data: null,
  error: null,
};

const goalCategoriesAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_GOAL_CATEGORY_ADMIN_REQUEST":
      return {
        ...initialState,
        loading: true,
      };
    case "FETCH_GOAL_CATEGORY_ADMIN_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_GOAL_CATEGORY_ADMIN_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "UPDATE_GOAL_CATEGORY_ADMIN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_GOAL_CATEGORY_ADMIN_SUCCESS":
      const updatedData = {
        ...state.data,
        records: state.data.records.map((cat) => {
          if (cat.id === action.payload.id) {
            return {
              ...cat,
              enable: action.payload?.enable,
              subCategory:
                cat.subCategory.length > 0
                  ? cat.subCategory.map((subC) => ({
                      ...subC,
                      enable: action.payload?.enable,
                    }))
                  : [],
            };
            // return action.payload;
          }
          return cat;
        }),
      };
      return {
        ...state,
        loading: false,
        data: updatedData,
        error: null,
      };

    case "UPDATE_GOAL_SUB_CATEGORY_ADMIN_SUCCESS":
      const updatedSubData = {
        ...state.data,
        records: state.data.records.map((cat) => {
          if (cat.id === action.payload.parent_category) {
            return {
              ...cat,
              // enable: action.payload?.enable
              //   ? true
              //   : cat.subCategory.some((subC) => subC.enable)
              //   ? true
              //   : false,
              subCategory: cat.subCategory.map((subC) =>
                subC.id == action.payload.id
                  ? { ...subC, enable: action.payload?.enable }
                  : subC
              ),
            };
            // return action.payload;
          }

          return cat;
        }),
      };

      const updatedSubDataN = {
        ...updatedSubData,
        records: updatedSubData.records.map((cat) => {
          if (cat.id === action.payload.parent_category) {
            return {
              ...cat,
              enable: action.payload?.enable
                ? true
                : cat.subCategory.some((subC) => subC.enable)
                ? true
                : false,
              // subCategory: cat.subCategory.map((subC) =>
              //   subC.id == action.payload.id
              //     ? { ...subC, enable: action.payload?.enable }
              //     : subC
              // ),
            };
            // return action.payload;
          }

          return cat;
        }),
      };

      return {
        ...state,
        loading: false,
        // data: updatedSubData,
        data: updatedSubDataN,
        error: null,
      };
    case "UPDATE_GOAL_CATEGORY_ADMIN_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CREATE_GOAL_CATEGORY_ADMIN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "CREATE_GOAL_CATEGORY_ADMIN_SUCCESS":
      const newData = {
        ...state.data,
        records: [...state.data.records, action.payload],
      };
      return {
        ...state,
        loading: false,
        data: newData,
        error: null,
      };
    case "CREATE_GOAL_CATEGORY_ADMIN_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "DELETE_GOAL_CATEGORY_ADMIN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "DELETE_GOAL_CATEGORY_ADMIN_SUCCESS":
      const deletedData = {
        ...state.data,
        records: state.data.records.filter(
          (cat) => cat.id !== parseInt(action.payload.id)
        ),
      };

      return {
        ...state,
        loading: false,
        data: deletedData,
        error: null,
      };
    case "DELETE_GOAL_CATEGORY_ADMIN_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default goalCategoriesAdminReducer;
